import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="w-full px-4 md:px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link
              to="/"
              className="font-heading text-xl md:text-2xl font-bold text-background-50 tracking-tight"
            >
              Kakobuy<span className="text-primary-500">.study</span>
            </Link>
            <p className="mt-4 text-sm text-background-50/60 leading-relaxed max-w-xs">
              Najlepszy przewodnik zakupowy Kakobuy Spreadsheet. Pomagamy Polakom bezpiecznie i tanio kupować produkty z Chin.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
              Szybkie Linki
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">
                  Strona Główna
                </Link>
              </li>
              <li>
                <Link to="/kakobuy-spreadsheet" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">
                  Kakobuy Spreadsheet
                </Link>
              </li>
              <li>
                <Link to="/kakobuy-guide" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">
                  Poradnik Kakobuy
                </Link>
              </li>
              <li>
                <Link to="/kakobuy-spreadsheet" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">
                  Zakupy z Chin
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
              Kategorie
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-50/60 hover:text-background-50 transition-colors"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* More Categories */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
              Więcej Kategorii
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-50/60 hover:text-background-50 transition-colors"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; {currentYear} Kakobuy.study. Wszelkie prawa zastrzeżone.
          </p>
          <div className="flex items-center gap-6">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors"
            >
              Kakobuy Spreadsheet
            </a>
            <Link to="/kakobuy-spreadsheet" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors">
              Poradnik
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}